// extracted by mini-css-extract-plugin
export default {"main-container":"BottomNavigation_main-container__0Dz4m","label":"BottomNavigation_label__ppkGt"};